import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.Drawer.CompanySelector', {
    addNewCompany: 'Add an organisation',
    noCompanyNoAdd: `You don't have a company.`,
    selectCompany: `Choose a company`,
});
